import { XcoreCore } from "XcoreCore";
import { BaseApiRequest } from "../baseApiRequest";

export interface Generate2faQRCodeParams {
  email: string;
  password: string;
}

export const generate2faQRCode = (core: XcoreCore, params: Generate2faQRCodeParams): BaseApiRequest<Response> =>
  core.fetch("/api/user/qrcode", {
    method: "POST",
    body: JSON.stringify(params),
  });
